module.exports = __webpack_public_path__ + "static/media/15.d71c06a4.jpg";